import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconBookSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M6.75 2C5.23122 2 4 3.23122 4 4.75V19.25C4 20.7688 5.23122 22 6.75 22H18.25C19.2165 22 20 21.2165 20 20.25V3.75C20 2.7835 19.2165 2 18.25 2H6.75ZM5.5 19V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H18.25C18.3881 20.5 18.5 20.3881 18.5 20.25V17.4823C18.4183 17.494 18.3349 17.5 18.25 17.5H7C6.17157 17.5 5.5 18.1716 5.5 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookSimple;
